jQuery( function ( $ ) {
    const sarchForm = $( '.c-searchform--header' );
    sarchForm.on( 'click', function() {
        if ( !$( this ).hasClass( 'is-active' ) ) {
            $( this ).addClass( 'is-active' );
            $( '.p-header' ).addClass( 'is-active' );
        }
    } );
    sarchForm.on( 'focusout', function() {
        if ( window.matchMedia( "(min-width: 600px)" ).matches ) {
            $( this ).removeClass( 'is-active' );
            $( '.p-header' ).removeClass( 'is-active' );
        }
    } );
    $( '.p-header__back' ).on( 'click', function() {
        sarchForm.removeClass( 'is-active' );
        $( '.p-header' ).removeClass( 'is-active' );
    } );
} );